import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  cardContainer: {
    textAlign: "center",
    cursor: "pointer",
    "& .cardImage": {
      display: "flex",
      flex: "1",
      justifyContent: "center",
      alignItems: "center"
    },
    "& .cardIDescription": {
      paddingTop: "65px",
      paddingBottom: "25px",
      background: "#ebebeb",
      marginTop: "-50px",
      marginBottom: "3px",
      marginLeft: "3px"
    },
    "&:hover .cardIDescription": {
      background: "#fafafa",
      borderRadius: "8px",
      boxShadow: "0px 0px 5px 0px rgb(50 50 50 / 45%)",
      zIndex: "15",
      width: "200px",
      marginLeft: "auto",
      marginRight: "auto"
    },
    "&:hover $btnPlanSlider": {
      background: "#0073cf"
    }
  },
  cardIMage: {
    height: "100px",
    width: "100px"
  },
  cardTitle: {
    fontSize: "24px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.17",
    letterSpacing: "-0.38px",
    color: "#0098db"
  },
  cardSubtitle: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.43",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#727272",
    marginTop: "20px",
    paddingLeft: "20px",
    paddingRight: "20px"
  },
  primaryButton: {
    background: "#0073cf",
    color: "white",
    marginTop: "20px"
  },
  btnPlanSlider: {
    color: "white",
    textDecoration: "none",
    width: "140px",
    height: "40px",
    borderRadius: "4px",
    backgroundColor: "#b5b5b5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
    marginRight: "auto"
  }
}));

export default styles;
